// apolloClient.js
import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { get, set, remove } from 'js-cookie';

// 1. Create an HTTP link to your GraphQL endpoint
const httpLink = new HttpLink({
    uri: `${process.env.FILE_URL}/graphql`,
});

// 2. Create a middleware to set custom headers
const authLink = setContext((_, { headers }) => {
    const localData = get(process.env.APP_COOKIE)
    console.log("localData", localData)
    const token = localData ? JSON.parse(localData).jwt : null;
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
            token: token,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        },
    };
});

// 3. Combine middleware with HTTP link
const client = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
});

export default client;
